// We can't do this easily with env vars
// import.meta.env.VITE_MOCK_REQUESTS === "1";
export var mockRequests = window.location.host.includes('localhost:3002');
